if (!customElements.get('pdp-promotion')) {
  customElements.define('pdp-promotion', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.section = this.closest('.js-product');
      this.form = document.getElementById(this.dataset.formId);
      this.button = this.form?.querySelector('[name="add"][data-pdp-promotion]');
      this.countdowns = this.section.querySelectorAll('[data-pdp-promotion-timer]');
      this.promotions = JSON.parse(this.querySelector('script').textContent);
      this.manualEnds = new WeakMap();
      this.variantId = this.dataset.selectedVariant;
      this.controller = new AbortController();
      this.section.addEventListener('on:variant:change', (event) => {
        if (event.detail.form !== this.form) return;
        // The picker rewrites button text even when the variant is unchanged.
        if (this.button) delete this.button.dataset.promotionVariant;
        this.variantId = event.detail.variant?.id;
        this.update();
      }, { signal: this.controller.signal });
      // Wait for the theme's product-form and variant-picker initial labels.
      this.frame = requestAnimationFrame(() => this.update());
      this.interval = setInterval(() => this.update(), 1000);
    }

    update() {
      const promotion = this.promotions[this.variantId];
      const now = Date.now();
      const priceActive = promotion?.available && promotion.validPrices
        && (!promotion.priceEndsAt || Date.parse(promotion.priceEndsAt) > now);
      if (this.button) {
        if (priceActive) {
          if (this.button.dataset.promotionVariant !== String(this.variantId)) {
            const label = document.createElement('span');
            label.textContent = `${this.button.dataset.addToCartText} – `;
            const sale = document.createElement('strong');
            sale.textContent = promotion.sale;
            const original = document.createElement('s');
            original.textContent = promotion.original;
            const prices = document.createElement('span');
            prices.className = 'pdp-promotion-prices';
            prices.append(sale, original);
            this.button.replaceChildren(label, prices);
            this.button.dataset.promotionVariant = this.variantId;
          }
        } else if (this.button.dataset.promotionVariant) {
          // VariantPicker owns sold-out and unavailable labels.
          if (promotion?.available) this.button.textContent = this.button.dataset.addToCartText;
          delete this.button.dataset.promotionVariant;
        }
      }
      this.countdowns.forEach((countdown) => {
        // Variant mode hides missing or expired deadlines; manual mode is separate.
        const { endDate, endTime, timeZone } = countdown.dataset;
        const key = JSON.stringify([endDate, endTime, timeZone]);
        if (this.manualEnds.get(countdown)?.key !== key) {
          this.manualEnds.set(countdown, {
            key,
            timestamp: this.constructor.parseManualEnd(endDate, endTime, timeZone)
          });
        }
        const endTimestamp = countdown.dataset.useVariantTime === 'true'
          ? Date.parse(promotion?.countdownEndsAt) : this.manualEnds.get(countdown).timestamp;
        const remaining = endTimestamp - now;
        countdown.hidden = !(remaining > 0);
        if (countdown.hidden) return;
        const seconds = Math.ceil(remaining / 1000);
        const minutes = Math.floor(seconds / 60);
        countdown.querySelector('[data-promotion-time]').textContent =
          `${Math.floor(minutes / 1440)}d ${Math.floor(minutes / 60) % 24}h ${minutes % 60}m ${String(seconds % 60).padStart(2, '0')}s`;
      });
    }

    static parseManualEnd(date = '', time = '', timeZone = 'America/New_York') {
      date = date.trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return NaN;
      const clock = time.trim() || '23:59';
      if (!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(clock)) return NaN;
      const target = Date.parse(`${date}T${clock}:00Z`);
      if (!Number.isFinite(target) || new Date(target).toISOString().slice(0, 10) !== date) return NaN;
      try {
        const formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone,
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        });
        let candidate = target;
        // Resolve the offset at the event date, including daylight saving time.
        for (let attempt = 0; attempt < 4; attempt += 1) {
          const parts = Object.fromEntries(formatter.formatToParts(candidate).map(({ type, value }) => [type, value]));
          const represented = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
          const next = target - (represented - candidate);
          if (next === candidate) return candidate;
          candidate = next;
        }
      } catch {
        // Invalid dates and unavailable timezones keep the countdown hidden.
      }
      return NaN;
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
